/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/5/19
 * Time: 11:40 AM
 */
import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';

import {Button as SementicBtn, Checkbox} from 'semantic-ui-react'
import '../ViewAllCheckIn/ViewAllCheckIn.css'
import {MDBDataTable} from 'mdbreact'
import * as common from '../../../const/Common/CommonFunc';
import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import {Tooltip} from "antd";
import SpinnerCheckBox from "../../../components/SpinnerCheckbox/SpinnerCheckBox";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import $ from 'jquery'
import Download from '../../../components/Button/DownloadbleButton'
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import apiConfig from "../../../axios/axios_api_services";
import {withTranslation} from "react-i18next";
import * as TableHeaders from '../../../const/table/TableHeaders';
import * as DropDownConst from '../../../store/Reducer/DropDownConst';

class History extends React.Component {

  state = {
    multipleSelection: false,
    smsChecked: true,
    isTag: false,
    search: false,
    visitorTag: {
      desc: null,
      tag: null
    },
    selectedColumn: "",
    searchDetails: "",
    checkout_visitors_temp: [],
    checkout_visitors: [],

    isTagged: false,
    isCheckOut: false,
    selected_visitors_cols: TableHeaders.selectedVisitorsColumns(this.props.t),
    checkOut_cols: TableHeaders.checkOutCols(this.props.t)
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.t !== this.props.t) {
      this.setState({
        selected_visitors_cols: TableHeaders.selectedVisitorsColumns(this.props.t),
        checkOut_cols: TableHeaders.checkOutCols(this.props.t)
      })
    }
  }

  DetailOnChange = (e, {value}) => {
    this.setState({selectedColumn: value});
  };
  DetailDescOnChange = (e) => {
    this.setState({searchDetails: e.target.value});
  };
  tagVisitors = () => {
    let tag_visitor_array = [];

    let visitors = this.state.checkout_visitors_temp;
    visitors.map((visitor, index) => {
      if (visitor.tag) {
        tag_visitor_array.push(visitor.visitorId);
      }
    });

    let tag_visitor_obj = {
      visitors: tag_visitor_array,
      remarkColour: this.state.visitorTag.tag,
      remark: this.state.visitorTag.desc
    };

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios.post(apiConfig.CORPORATE_VISITOR_TAG_REMARK(corporateId), tag_visitor_obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          this.getAllOverdueVisitors(2);
          this.setState({
            isTag: !this.state.isTag,
            multipleSelection: false,
          });

        } else {
          this.props.spinnerHandler(false);
          common.warningAlert("Tag failed", 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.tagVisitors();
        } else {
          this.props.spinnerHandler(false)
        }
      });

  };
  checkoutVisitors = () => {
    let checkout_visitor_array = [];

    let visitors = this.state.checkout_visitors_temp;
    visitors.map((visitor, index) => {
      if (visitor.check) {
        checkout_visitor_array.push(visitor.meetingVisitorId);
      }
    });

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    const obj = {
      visitors: checkout_visitor_array,
      sendSms: this.state.smsChecked
    };

    // Get All Current Check In User List Of Corporate
    axios.post(apiConfig.CORPORATE_VISITORS_OVERDUE_CHECKOUT, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.getAllOverdueVisitors(1);
          this.setState({
            multipleSelection: false,
          });

        } else {
          this.props.spinnerHandler(false);
          common.warningAlert("Checkout failed", 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.checkoutVisitors();
        } else {
          this.props.spinnerHandler(false)
        }
      });
  };
  loadCheckoutVisitors = (list) => {
    this.setState({
      checkout_visitors_temp: list
    })
  };
  visitorDescOnChange = (e) => {
    const visitorTag = {
      ...this.state.visitorTag
    };
    visitorTag.desc = e.target.value;
    this.setState({
      visitorTag: visitorTag
    });
  };
  visitorTagOnChange = (e, {value}) => {
    const visitorTag = {
      ...this.state.visitorTag
    };
    visitorTag.tag = value;
    this.setState({
      visitorTag: visitorTag
    });
  };

  async buttonClick(e, type) {

    switch (type) {
      case 'details':
        if (this.state.searchDetails === null || this.state.selectedColumn === null || this.state.searchDetails.trim() === "" || this.state.selectedColumn.trim() === "") {
          common.notifyMessage("please select Column and fill Search Text");
          this.loadCheckoutVisitors(this.state.checkout_visitors)
        } else {
          let custom_array = [];

          let searchText = this.state.searchDetails.trim().toUpperCase();
          let searchCol = this.state.selectedColumn;

          let all_visitors = this.state.checkout_visitors;
          all_visitors.map((visitor, index) => {

            if (visitor[searchCol] !== null) {
              if (visitor[searchCol].toUpperCase().indexOf(searchText) > -1) {
                custom_array.push(visitor)
              }
            }
          });
          this.loadCheckoutVisitors(custom_array);
        }

        break;
      case 'refresh':
        this.getAllOverdueVisitors();
        break;

      case 'tag':
        if (!this.state.multipleSelection) {
          common.notifyMessage("Please Select Visitor!");
        } else if (this.state.visitorTag.desc === null || this.state.visitorTag.tag === null) {
          common.notifyMessage("please select Tag and Description");

        } else if (this.state.visitorTag.desc.trim() === "") {
          common.notifyMessage("please Enter Tag Description");
        } else {
          this.tagVisitors();
        }
        break;
      case 'tagEnable':
        this.setState({isTag: !this.state.isTag});
        break;

      case 'checkOut':
        const {t} = this.props;
        if (!this.state.multipleSelection) {
          common.notifyMessage("Please Select Visitor!");
        } else {
          swal({
            title: t('do_you_want_to_check_out_these_visitors?'),
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: t('cancel'),
              dangerMode: {
                text: t('yes'),
                value: "action",
                className: "okay-btn"
              }
            },
          }).then((value) => {
            switch (value) {
              case "action":
                this.checkoutVisitors();
                break;
              default:
            }
          });
        }
        break;

      default:
    }
  };

  async getAllOverdueVisitors(type) {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    // Get all overdue visitors
    await axios.get(apiConfig.CORPORATE_VISITORS_OVERDUE(coperateId), {headers: headers})
      .then(async response => {
        let _array = [];
        this.props.spinnerHandler(false);

        if (response.data.success) {

          let visitors = response.data.overdueList;
          // console.log(visitors);

          if (visitors.length !== 0) {
            visitors.map((visitor, index) => {
              let obj = {...visitor, check: false, tag:false};
              _array.push(obj);
            })
          }
        }

        this.setState({
          checkout_visitors_temp: _array,
          checkout_visitors: _array
        });
      })

      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllOverdueVisitors(type);
        } else {
          this.props.spinnerHandler(false)
        }
      })

      .finally(fin => {
        // call get all counts
        this.props.callAllCount(this.props.usr_obj)

        if (type === 1) {
          common.warningAlert("Checkout successfully", 0)
        } else if (type === 2) {
          common.warningAlert("Tag visitor successfully", 0)
        }
      });
  };

  async componentDidMount() {
    await this.getAllOverdueVisitors();
  }

  onCheckBoxChange(e, index) {
    switch (index) {
      case 'sms':
        this.setState({
          smsChecked: !this.state.smsChecked
        });
        break;
      default:

        let visitors = this.state.checkout_visitors_temp;
        const passNumber = visitors[index].passNumber;

        visitors.map((v, i) => {
          if (v.passNumber === passNumber) {
            visitors[i].check = !visitors[i].check;
          } else {
            // visitors[i].check = false;
          }
          visitors[i].tag = false;
        });

        this.loadCheckoutVisitors(visitors);

        let exist = false;
        this.state.checkout_visitors_temp.map((v, i) => {
          if (v.check) {
            exist = true;
          }
        });
        this.setState({multipleSelection: exist,isCheckOut: exist,isTagged: false});
        if (!exist) {
          this.setState({
            isTag: false
          })
        }
    }
  };

  onTagCheckBoxChange(e, index) {
    let visitors = this.state.checkout_visitors_temp;
    visitors[index].tag = !visitors[index].tag;

    visitors.map((v, i) => {
      visitors[i].check = false;
    });
    this.loadCheckoutVisitors(visitors);

    let exist = false;
    this.state.checkout_visitors_temp.map((v, i) => {
      if (v.tag) {
        exist = true;
      }
    });
    this.setState({multipleSelection: exist,isTagged: exist,isCheckOut:false});
    if (!exist) {
      this.setState({
        isTag: false
      })
    }

  };
  passnumberDropdownHandler = (e,{value}) => {
    let visitors = this.state.checkout_visitors_temp;
    const passNumber = visitors[value].passNumber;

    visitors.map((v, i) => {
      if (v.passNumber === passNumber) {
        visitors[i].check = true;
      } else {
        // visitors[i].check = false;
      }
      visitors[i].tag = false;
    });

    this.loadCheckoutVisitors(visitors);

    let exist = false;
    this.state.checkout_visitors_temp.map((v, i) => {
      if (v.check) {
        exist = true;
      }
    });
    this.setState({multipleSelection: exist,isCheckOut: exist,isTagged: false});
    if (!exist) {
      this.setState({
        isTag: false
      })
    }
  };

  render() {
    const {t} = this.props;
    let selectedVisitors = [];
    this.state.checkout_visitors_temp.map((value, index) => {
      if (value.check) {
        selectedVisitors.push(
          {
            checkOut:
              <center>
                <SpinnerCheckBox check={value.check} onCheckBoxChange={e => this.onCheckBoxChange(e, index)}/>
              </center>,
            passNumber: value.passNumber,
            visitorIdentity: value.visitorIdentity,
            visitor: value.visitorName,
            visitorMobile: value.visitorMobile
          }
        );
      }
    });
    let selectedVisitorCols = this.state.selected_visitors_cols;
    let table_selected_visitors_data = {columns:selectedVisitorCols, rows:selectedVisitors};
    let passnumber_dropdown = [];

    let rows = [];
    this.state.checkout_visitors_temp.map((value, index) => {
      rows.push(
        {
          checkOut:
            <center>
              <SpinnerCheckBox check={value.check} onCheckBoxChange={e => this.onCheckBoxChange(e, index)}/>
            </center>,
          tagColor: <SpinnerCheckBox check={value.tag} isColor={value.tagColour !== null} color={value.tagColour}
                                     onCheckBoxChange={e => this.onTagCheckBoxChange(e, index)}/>,
          status: value.status,
          passNumber: value.passNumber,
          checkedIn: value.checkedIn,
          checkedOut: value.checkedOut !== null ? value.checkedOut : "-",
          host1: value.host1,
          host1Mobile: value.host1Mobile,
          host2: value.host2 !== null ? value.host2 : "-",
          host2Mobile: value.host2Mobile !== null ? value.host2Mobile : "-",
          visitor: value.visitorName,
          visitorIdentity: value.visitorIdentity,
          visitorMobile: value.visitorMobile,
          company: value.company !== null ? value.company : "-",
          purposeOfVisit: value.visitingPurpose,
          activatedPackage: value.activatedPackage !== null ? value.activatedPackage : "Not requested",
          generatedPin: value.generatedPin !== null ? value.generatedPin : "Not requested",
          expireDate: value.expireDate !== null ? value.expireDate : "Not requested",
          registrationStatus: value.registrationStatus,
          receptionistName: value.receptionistName
        }
      );
      let text = value.passNumber + " - " + value.visitorIdentity;
      const data = {
        key: index,
        text: text,
        value: index
      };
      passnumber_dropdown.push(data)
    });


    let columns = this.state.checkOut_cols;
    let table_data = {columns, rows};
    passnumber_dropdown.sort((a, b) => a.text.localeCompare(b.text));
    return (
      <div>
        {/*{
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{this.props.route_name}</h4>
            :<h4 className={"route-none-style"}/>
        }*/}

        {
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{t('overdue_visitors')}</h4>
            :<h4 className={"route-none-style"}/>
        }

        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                {t('search_details')}
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    <Col xs="4" sm="4" md="4" lg="4" xl="4" id={'selectColumn'}>
                      <LabelDropdown
                        clearable
                        required
                        btnText={"Search"}
                        tagText={t('select_column')}
                        placeholder={t('select_column')}
                        options={DropDownConst.selectCols(t)}
                        onChange={this.DetailOnChange}
                      />
                    </Col>
                    <Col xs="4" sm="4" md="5" lg="5" xl="5" id={'lblSearch'}>
                      <LabelInput
                        required
                        tagText={t('search')}
                        placeholder={t('search_details')}
                        // value={this.state.host_extension}
                        onChange={this.DetailDescOnChange}
                      />
                    </Col>


                    <Col xs="4" sm="4" md="3" lg="3" xl="3">
                      <Row>
                        <Col xs="10" sm="10" md="10" lg="10" xl="10">
                          <Button
                            className="height yellow-btn"
                            block
                            onClick={e => this.buttonClick(e, 'details')}
                          >{t('search')}</Button>
                        </Col>

                        <Col xs="2" sm="2" md="2" lg="2" xl="2" style={{padding: '0'}}>
                          <Tooltip placement="topLeft" title="Refresh (current check-in visitors)">
                            <SementicBtn onClick={e => this.buttonClick(e, 'refresh')} circular icon='refresh'/>
                          </Tooltip>
                        </Col>
                      </Row>

                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                {t('overdue_visitors')}
                <DrpDwn
                  className={"searchvisitor-checkbox"}
                  placeholder={t('search_visitor')}
                  options={passnumber_dropdown}
                  value={''}
                  onChange={this.passnumberDropdownHandler}
                />
                <Download data={this.state.checkout_visitors_temp} userType={"VISITOR_OVERDUE"}/>
              </CardHeader>
              <CardBody>

                {
                  this.state.multipleSelection ?
                    <Card className="card ">
                      <CardHeader className="paddingBottom">
                        <Row>
                          <Col sm="2">
                            {
                              this.state.isCheckOut ?
                                <Tooltip placement="topLeft" title="Check out visitors">
                                  <SementicBtn className="Width  MarginBottom ui button px-5" onClick={e => this.buttonClick(e, 'checkOut')}
                                               icon='edit'/>
                                </Tooltip>
                                :null
                            }
                            {
                              this.state.isTagged ?
                                <Tooltip placement="topLeft" title="Tag visitors">
                                  <SementicBtn className="Width  MarginBottom ui button px-5" onClick={e => this.buttonClick(e, 'tagEnable')}
                                               icon='tags'/>
                                </Tooltip>
                                :null
                            }

                          </Col>
                          <Col sm="9">
                            {
                              this.state.isCheckOut ?
                                <Checkbox
                                  toggle
                                  checked={this.state.smsChecked}
                                  onChange={e => this.onCheckBoxChange(e, 'sms')}
                                  className="MarginBottom  MarginTop"
                                  label={t('visitor_receives_sms')}
                                />
                                :null
                            }

                          </Col>
                        </Row>
                      </CardHeader>
                      {
                        this.state.isTag ?
                          <CardBody className="paddingBottom">
                            <div className="form-group">
                              <Row>
                                <Col xs="4" sm="4" md="4" lg="4" xl="4">
                                  <LabelDropdown
                                    required
                                    btnText={"Check Out"}
                                    tagText={t('select_tag')}
                                    placeholder={t('select_tag')}
                                    options={this.props.tags}
                                    onChange={this.visitorTagOnChange}
                                  />

                                </Col>
                                <Col xs="4" sm="4" md="5" lg="5" xl="5">
                                  <LabelInput

                                    tagText={"Tag Remark"}
                                    placeholder={"Tag Remark"}
                                    // value={this.state.host_extension}
                                    onChange={this.visitorDescOnChange}
                                  />
                                </Col>

                                <Col xs="3" sm="3" md="2" lg="2" xl="2">
                                  <Button
                                    className="height"
                                    block
                                    color="primary"
                                    onClick={e => this.buttonClick(e, 'tag')}
                                  >Tag Visitor</Button>
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                          : null
                      }

                    </Card>
                    : null
                }
                {
                  selectedVisitors.length !== 0 ?
                    <Card className="card ">
                      <CardHeader className="paddingBottom">

                        {t('selected_visitors')}
                      </CardHeader>
                      <CardBody className=" paddingBottom">
                        <Row>
                          <Col lg="12">
                            <MDBDataTable
                              // id={"checkin-table-custom-style"}
                              displayEntries={false}
                              exportToCSV={true}
                              searching={false}
                              responsive
                              responsiveSm
                              responsiveMd
                              responsiveLg
                              responsiveXl
                              striped={false}
                              bordered
                              hover
                              data={table_selected_visitors_data}/>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    :null
                }

                <Row>
                  <Col lg="12">

                    <MDBDataTable
                      id={"overdue-table-custom-style"}
                      exportToCSV={true}
                      searching={true}
                      entriesLabel={t('show_entries')}
                      searchLabel={t('search_overdue_visitor')}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      // striped={true}
                      bordered
                      hover
                      data={table_data}/>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({

  checkoutColumns: state.viewAllCheckIN.checkoutColumns,
  column: state.viewAllCheckIN.column,
  tags: state.viewAllCheckIN.tags,
  selectedVisitorsColumns: state.viewAllCheckIN.selectedVisitorsColumns,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllCount: (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(History));
